import React from "react";
import moment from "moment";

export const SelectedMinorInfoCard = props => (
  <div className="visitor-data">
    <dl className="general-info">
      <dt>visitor name</dt>
      <dd className="body-bold">
        {props.firstName}&nbsp;{props.middleName}&nbsp;{props.lastName}
      </dd>
    </dl>
    <dl className="secondary-info">
      <div>
        <dt>Date of Birth:&nbsp;</dt>
        <dd>{moment(props.dob).format("MM/DD/YYYY")}</dd>
      </div>
      <div>
        <dt>Last 4 of SSN:&nbsp;</dt>
        <dd>{props.ssn}</dd>
      </div>
      <div>
        <dt>Place of Birth:&nbsp;</dt>
        <dd>{props.pob}</dd>
      </div>
      <div>
        <dt>Race:&nbsp;</dt>
        <dd>{props.race}</dd>
      </div>
      <div>
        <dt>Sex:&nbsp;</dt>
        <dd>{props.sex}</dd>
      </div>
    </dl>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/SelectedMinorInfoCard/SelectedMinorInfoCard.js